import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { sortAlphabeticalAsc } from 'utils/sortHelper'

export const selectAvailableUnits = createSelector(
  [(state: ApplicationState) => state.AvailableUnitsStore.data],
  (data) => [...data].sort(sortAlphabeticalAsc)
)

export const selectAvailableUnitsFetched = createSelector(
  [(state: ApplicationState) => state.AvailableUnitsStore.fetched],
  (fetched) => fetched
)
